import dynamic from 'next/dynamic'

export const DynamicMoreLikeThisItemsDrawer = dynamic(
  () => import('.').then((mod) => mod.MoreLikeThisItemsDrawer),
  { ssr: false },
)
